import { render } from "./project-report.vue?vue&type=template&id=5c8828c6"
import script from "./project-report.vue?vue&type=script&lang=js"
export * from "./project-report.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__